import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export const Contact = () => {
  const mapSrc =
    "https://www.google.com/maps?q=Rua+T%C3%A2nia,+329+-+Jardim+Carapicu%C3%ADba,+Carapicu%C3%ADba+-+SP&output=embed";

  return (
    <section
      id="contato"
      data-testid="contact-section"
      className="relative py-24 lg:py-32 bg-mist"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5 reveal">
              <span className="divider-gold" />
              <span className="tracking-eyebrow text-gold">Contato</span>
            </div>
            <h2
              className="font-display text-4xl lg:text-5xl font-bold text-navy leading-[1.05] tracking-[-0.025em] reveal"
              data-testid="contact-title"
            >
              Estamos prontos.
              <br />
              A operação continua.
            </h2>
            <p className="mt-6 text-lg text-slate-600 max-w-lg reveal">
              Fale com um especialista da Imporparts. Atendimento de segunda a domingo,
              das 08:00 às 18:00.
            </p>
          </div>
          <div className="lg:col-span-6 flex lg:items-end lg:justify-end reveal">
            <a
              href={BRAND.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-btn"
              className="btn-primary text-base"
            >
              <MessageCircle className="w-5 h-5" />
              Chamar no WhatsApp
            </a>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 space-y-4">
            <InfoRow
              icon={MapPin}
              title="Endereço"
              text={`${BRAND.address.street}, ${BRAND.address.district}, ${BRAND.address.city} — ${BRAND.address.state}`}
              testid="contact-address"
            />
            <InfoRow
              icon={Phone}
              title="Telefone"
              text={BRAND.phone}
              href={`tel:+551126704419`}
              testid="contact-phone"
            />
            <InfoRow
              icon={MessageCircle}
              title="WhatsApp"
              text={BRAND.whatsapp}
              href={BRAND.whatsappLink}
              external
              testid="contact-whatsapp-info"
            />
            <InfoRow
              icon={Mail}
              title="E-mail"
              text={BRAND.email}
              href={`mailto:${BRAND.email}`}
              testid="contact-email"
            />
            <InfoRow
              icon={Clock}
              title="Horário"
              text={BRAND.address.hours}
              testid="contact-hours"
            />
          </div>
          <div className="lg:col-span-7 reveal">
            <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-xl aspect-[16/11]">
              <iframe
                title="Localização Imporparts"
                src={mapSrc}
                width="100%"
                height="100%"
                loading="lazy"
                style={{ border: 0 }}
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const InfoRow = ({ icon: Icon, title, text, href, external, testid }) => {
  const inner = (
    <div className="flex items-start gap-4 rounded-2xl bg-white border border-slate-200 p-5 card-lift">
      <div className="w-11 h-11 rounded-xl bg-navy text-white flex items-center justify-center shrink-0">
        <Icon className="w-5 h-5" />
      </div>
      <div>
        <div className="tracking-eyebrow text-gold text-[10px] mb-1">{title}</div>
        <div className="text-slate-800 font-medium leading-snug">{text}</div>
      </div>
    </div>
  );
  return href ? (
    <a
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      className="block reveal"
      data-testid={testid}
    >
      {inner}
    </a>
  ) : (
    <div className="reveal" data-testid={testid}>
      {inner}
    </div>
  );
};
